import React from 'react';
import { FileIcon } from '@wix/ambassador-file-sharing-v1-settings/types';
import { ITEMTYPE } from '../../../../../../../Constants/ItemType.Constants';
import { getFileIcon } from '../../../../../../Shared/FileAndFolderIcon/getFileIcon';
import { getFolderIcon } from '../../../../../../Shared/FileAndFolderIcon/getFolderIcon';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import {
  getAppSettings,
  getSettingsData,
} from '../../../../../../Services/AppSettings.service';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { ENABLE_NEW_THUMBNAIL_SKINS_FO_FILE_SHARE_PANELS } from '../../../../../../../experiments';
import {
  FileShareFill,
  FileShareLabel,
  FileShareLine,
} from '@wix/design-system-illustrations';

const ItemNameIcon = (props: any) => {
  const [, AppSettings]: any = useObservable(getAppSettings());
  const [, settingsData]: any = useObservable(getSettingsData());
  const { experiments } = useExperiments();
  const isThumbnailWdsEnabled = experiments.enabled(ENABLE_NEW_THUMBNAIL_SKINS_FO_FILE_SHARE_PANELS);
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';
  const { item } = props;
  const fileIconStyle: FileIcon =
    settingsData?.settings?.designSettings?.fileIcon;
  const fileIconsColoredByType: boolean =
    settingsData?.settings?.designSettings?.fileIconsColoredByType ?? true;
  const isMembersArea = AppSettings?.isMembersArea ?? false;

  if (isThumbnailWdsEnabled) {
    if (ITEMTYPE.FOLDER in item) {
      return <>{getFolderIcon(fileIconStyle, isMobile)}</>;
    }
    const wdsW = isMobile ? 24 : 40;
    const wdsH = isMobile ? 24 : 44;
    const wdsClip = {
      width: wdsW,
      height: wdsH,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    } as const;
    if (fileIconStyle === FileIcon.EXTENSION) {
      return (
        <span style={wdsClip}>
          <FileShareLabel />
        </span>
      );
    }
    if (fileIconStyle === FileIcon.LINE) {
      return (
        <span style={wdsClip}>
          <FileShareLine />
        </span>
      );
    }
    return (
      <span style={wdsClip}>
        <FileShareFill />
      </span>
    );
  }

  return (
    <>
      {ITEMTYPE.FILE in item
        ? getFileIcon(
            item?.fileFields?.extension?.toUpperCase(),
            fileIconStyle,
            isMobile,
            fileIconsColoredByType,
            isMembersArea,
          )
        : ITEMTYPE.FOLDER in item
        ? getFolderIcon(fileIconStyle, isMobile)
        : null}
    </>
  );
};

export default ItemNameIcon;
